import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectCurrentToken } from "../features/slices/authSlice";
import { useGetProfileQuery } from "../features/api/userApiSlice";

export default function LiveChatPrefill() {
  const token = useSelector(selectCurrentToken);
  const { data: userProfile } = useGetProfileQuery({ prefetch: true }, { skip: !token });

  useEffect(() => {
    if (!userProfile) return;

    const prefill = () => {
      const { fullname, email, username, playerRank, accumulatedDeposit, activityPoint } = userProfile.result ?? {};
      window.LiveChatWidget.call('set_customer_name', fullname);
      window.LiveChatWidget.call('set_customer_email', email);
      window.LiveChatWidget.call('set_session_variables', {
        username,
        player_rank: playerRank,
        accumulated_deposit: accumulatedDeposit ?? 0,
        activity_point: activityPoint ?? 0,
        bo_link: process.env.REACT_APP_BO_URL && username
          ? `${process.env.REACT_APP_BO_URL}/list/customer?username=${encodeURIComponent(username)}`
          : '',
      });
    };

    if (!window.LiveChatWidget) {
      return;
    }

    if (window.LiveChatWidget._h) {
      prefill();
    } else {
      window.LiveChatWidget.on('ready', prefill);
      return () => window.LiveChatWidget.off('ready', prefill);
    }
  }, [userProfile]);

  return null;
}
